const axios = require('axios');

var client = axios.create();
export default {
  list: () => client.get('/archief/overzicht.json',{
		transformResponse: [function (data) {
			return JSON.parse(data);
		}]
	}),
  load: (year) => client.get('/archief/'+year+'.json',{
		transformResponse: [function (data) {
			return JSON.parse(data);
		}]
	})
}
